import React from 'react';
import s from './AdrData.scss';

const AdrData = () => (
  <div className={`${s.adrDataWrap} ${s.boxWrap}`}>
    <span className={s.logo}>
      <i />
    </span>{' '}
    <div>
      <span>Disclaimer:</span> This Data is provided by the Association for
      Democratic Reforms (ADR) | MyNeta and sourced from election affidavits
      available in the public domain of the Election Commission of India.
    </div>
  </div>
);

export default AdrData;
